module.exports = __webpack_public_path__ + "img/zi_1.f1482acc.png";